export default "__VITE_ASSET__DfTUIdh0__"